export default class Store {
  getAll(type) {
    throw new Error('You have to implement getAll method!');
  }
  get(type, id) {
    throw new Error('You have to implement get method!');
  }
  add(type, obj) {
    throw new Error('You have to implement add method!');
  }
  remove(type, id) {
    throw new Error('You have to implement remove method!');
  }
  update(type, id, obj) {
    throw new Error('You have to implement update method!');
  }
}
